import {ReactPortal} from '@components/common/react-portal/react-portal'
import {Overlay} from '@components/overlay'
import {cn} from '@containers/html-utils'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {useDraggableStore} from './draggable/draggable-store'
import {allDayTasksContainerId, regularTasksContainerId} from './week'

export const MoveOverlay = observer(({allDay = false}: {allDay?: boolean}) => {
  const [state, store] = useDraggableStore()

  const onMouseMove = (e: React.MouseEvent) => {
    const x = e.pageX - state.initialX
    const y = e.pageY - state.initialY

    store.setTraveled(x, y)
  }

  return (
    <ReactPortal
      elementId={allDay ? allDayTasksContainerId : regularTasksContainerId}
    >
      <div>
        <Overlay
          onMouseMove={onMouseMove}
          className={cn(
            (state.enabled ||
              state.draggedItem.changeAction === 'change-deadline') &&
              'cursor-grabbing'
          )}
        />
      </div>
    </ReactPortal>
  )
})
